<!--
 * @Description: 富友银行
 * @Date: 2025-05-20 18:00:29
-->
<template>
  <div class="account-info__items">
    <template v-if="showOpenWay">
      <BaseTextTitle class="account-info__items__title">开通方式</BaseTextTitle>
      <BaseTextContent
        class="account-info-is-over-six-months-wrap"
        :class="{ 'is-hide-fy-channel': !showFyChannel }"
      >
        <div class="account-info-is-over-six-months">
          <div
            v-for="item in IS_OVER_SIX_MONTHS_OPTIONS"
            :key="item.value"
            class="account-info-is-over-six-months__card"
            :class="{ 'is-active': formData.isOverSixMonths === item.value }"
          >
            <div class="account-info-is-over-six-months__title">
              {{ item.title }}
            </div>
            <div class="account-info-is-over-six-months__desc">
              {{ item.desc }}
            </div>
          </div>
        </div>
        <!-- 分割线放内容区内，左右随内容留白，不上贯穿 -->
        <div
          v-if="showFyChannel"
          class="account-info-is-over-six-months__divider"
        ></div>
      </BaseTextContent>
    </template>

    <template v-if="showFyChannel">
      <BaseTextTitle
        class="account-info__items__title"
        :class="{ 'account-info__items__title--follow': showOpenWay }"
      >
        富友支付开户银行
      </BaseTextTitle>
      <BaseTextContent
        style="display: flex; flex-direction: column; padding-top: 0"
      >
        <div style="display: flex; width: 100%">
          <div style="margin: 5px 16px 0 0">
            <span style="color: red">*</span>
            请选择开户银行
          </div>
          <BaseFormItem
            prop="fyChannel"
            :rules="[
              {
                required: true,
                trigger: 'change',
                message: '请选择'
              }
            ]"
            style="margin-bottom: 0"
          >
            <BaseRadioGroup v-model="formData.fyChannel">
              <BaseRadio
                v-for="item in FY_CHANNEL"
                :key="item.value"
                :value="item.value"
              >
                {{ item.label }}
              </BaseRadio>
            </BaseRadioGroup>
          </BaseFormItem>
        </div>
        <div>预计开户时间：{{ tipsDay }}个工作日，实际以银行审核结果为准</div>
      </BaseTextContent>
    </template>
  </div>
</template>

<script lang="ts" setup>
import { computed, watchEffect } from 'vue';
import {
  BaseFormItem,
  BaseRadio,
  BaseRadioGroup,
  BaseTextContent,
  BaseTextTitle
} from 'xrk-components';
import { storeToRefs } from 'pinia';
import { FY_CHANNEL, IS_OVER_SIX_MONTHS_OPTIONS } from '../../constants';
import infoStore from '../../store/info';
import appStore from '@/store';

const { formData } = storeToRefs(infoStore());
const { info: userInfo } = storeToRefs(appStore.useUserStoreSetup);

/** 供应商不涉及开通方式相关逻辑 */
const isSupplier = computed(() => userInfo.value.functionCode === 3);

/** 供应商不展示开通方式 */
const showOpenWay = computed(() => !isSupplier.value);

/**
 * 展示开户银行：
 * - 供应商：始终展示（与改前一致）
 * - 非供应商：仅开通富友支付时不展示
 */
const showFyChannel = computed(
  () => isSupplier.value || formData.value.isOverSixMonths !== 0
);

const tipsDay = computed(() => {
  return formData.value.fyChannel === '01' ? '1' : '1-2';
});

watchEffect(() => {
  // 非供应商 + 仅开通富友支付：固定中信百信银行
  if (!isSupplier.value && formData.value.isOverSixMonths === 0) {
    formData.value.fyChannel = '01';
  }
  if (formData.value.fyChannel !== '01') {
    !formData.value.fyBeneficiaryInfoList.length &&
      (formData.value.fyBeneficiaryInfoList = [
        {
          name: null,
          certTp: null,
          certNo: null,
          validDateStart: null,
          validDateEnd: null,
          mobile: null,
          address: null,
          portraitFilePath: null,
          badgeFilePath: null,
          beneficiaryType: null
        }
      ]);
    !formData.value.fyShareholderInfoList.length &&
      (formData.value.fyShareholderInfoList = [
        {
          name: null,
          certTp: null,
          certNo: null,
          validDateStart: null,
          validDateEnd: null,
          mobile: null,
          portraitFilePath: null,
          badgeFilePath: null
        }
      ]);
  } else {
    formData.value.fyBeneficiaryInfoList = [];
    formData.value.fyShareholderInfoList = [];
  }
});
</script>
